import script from "./CampaignContent.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignContent.vue?vue&type=script&setup=true&lang=js"

import "./CampaignContent.vue?vue&type=style&index=0&id=0a5905fa&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a5905fa"]])

export default __exports__